import { objectValueOrDefault, configQuery, ValidationGuard, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata, __assign } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_PROFILE_DATA, USER_JURISDICTION_QUERY, BALANCE_CURRENCY_UPDATED } from '@gig/magic-messages';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';
import { validationMixin } from 'vuelidate';
import { minValue, maxValue, numeric } from 'vuelidate/lib/validators';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { CoreXLimitDuration, CoreXLimitType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/getUserTransactionLimits';
import { isUKGC } from '@gig/magic-jurisdictions';

var DEFAULT_MAX_CAP = 10000;
// Limits this component is to request from the user.
var PERIODS = [
    {
        period: CoreXLimitDuration.ONE_DAY,
        name: 'daily',
    },
    {
        period: CoreXLimitDuration.ONE_WEEK,
        name: 'weekly',
    },
    {
        period: CoreXLimitDuration.ONE_MONTH,
        name: 'monthly',
    },
];
/**
 * The `magic-corex-set-limits` component allows the
 * user to set a deposit limit or acknowledge not to set deposit limits.
 */
var SetLimitsComponent = /** @class */ (function (_super) {
    __extends(SetLimitsComponent, _super);
    function SetLimitsComponent() {
        var _a;
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isSubmitting = false;
        _this.isLoading = true;
        _this.responsibleGamingLimitCap = [];
        _this.subscription = null;
        _this.currentPeriodMaxError = DEFAULT_MAX_CAP;
        _this.isUKGC = false;
        _this.currency = Currency.EUR;
        _this.periods = PERIODS;
        _this.depositValues = (_a = {},
            _a[CoreXLimitDuration.ONE_DAY] = null,
            _a[CoreXLimitDuration.ONE_WEEK] = null,
            _a[CoreXLimitDuration.ONE_MONTH] = null,
            _a);
        return _this;
    }
    Object.defineProperty(SetLimitsComponent.prototype, "activePeriod", {
        get: function () {
            for (var _i = 0, PERIODS_1 = PERIODS; _i < PERIODS_1.length; _i++) {
                var period = PERIODS_1[_i].period;
                var value = this.depositValues[period];
                if (value !== null && value !== undefined && "" + value !== '') {
                    return period;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    SetLimitsComponent.prototype.isFieldDisabled = function (period) {
        return this.activePeriod !== null && this.activePeriod !== period;
    };
    SetLimitsComponent.prototype.validateAtLeastOne = function () {
        for (var _i = 0, PERIODS_2 = PERIODS; _i < PERIODS_2.length; _i++) {
            var period = PERIODS_2[_i].period;
            var rawValue = this.depositValues[period];
            if (!rawValue) {
                continue;
            }
            var value = Number(rawValue);
            if (value < 1) {
                continue;
            }
            if (value > this.getLimitCap(period)) {
                continue;
            }
            return true;
        }
        return false;
    };
    SetLimitsComponent.prototype.getAmountError = function (period) {
        return this.$t('create-limits.error.max', {
            minValue: 1,
            maxValue: this.getLimitCap(period),
        });
    };
    SetLimitsComponent.prototype.setLimits = function () {
        return __awaiter(this, void 0, void 0, function () {
            var depositValues_1, user, filledPeriod, value, lastFinancialLimitReviewOnUtc, params, updatedProfile, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isSubmitting) {
                            return [2 /*return*/];
                        }
                        this.isSubmitting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        depositValues_1 = this.depositValues;
                        user = magic.session.getUser();
                        if (!user) {
                            return [2 /*return*/];
                        }
                        filledPeriod = PERIODS.find(function (_a) {
                            var period = _a.period;
                            return !!depositValues_1[period];
                        });
                        if (!filledPeriod) {
                            return [2 /*return*/];
                        }
                        value = depositValues_1[filledPeriod === null || filledPeriod === void 0 ? void 0 : filledPeriod.period];
                        if (!value || Number(value) <= 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, magic.methods.responsibleGaming.createUserTransactionLimit(CoreXLimitType.DEPOSIT, filledPeriod === null || filledPeriod === void 0 ? void 0 : filledPeriod.period, this.currency, Number(value), CoreXMediatorType.SPORTS)];
                    case 2:
                        _a.sent();
                        lastFinancialLimitReviewOnUtc = new Date();
                        params = {
                            lastFinancialLimitReviewOnUtc: lastFinancialLimitReviewOnUtc.toISOString(),
                        };
                        return [4 /*yield*/, magic.methods.users.updateUserProfile(params)];
                    case 3:
                        updatedProfile = _a.sent();
                        if (!updatedProfile) return [3 /*break*/, 5];
                        return [4 /*yield*/, window.eventBus.publish(USER_PROFILE_DATA, updatedProfile)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.emitSuccess(depositValues_1);
                        notificationService.show(this.$t('set-deposit-limits.success'), {
                            style: NotificationStyle.SUCCESS,
                            uniqueID: 'set-deposit-limits-succes',
                        });
                        return [3 /*break*/, 8];
                    case 6:
                        e_1 = _a.sent();
                        console.error('Set deposit limits:', e_1);
                        this.emitError(e_1);
                        notificationService.show(this.$t('error.generic'), {
                            style: NotificationStyle.ERROR,
                            uniqueID: 'set-deposit-limits-error-generic',
                        });
                        return [3 /*break*/, 8];
                    case 7:
                        this.isSubmitting = false;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SetLimitsComponent.prototype.acknowledge = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lastFinancialLimitReviewOnUtc, params, updatedProfile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lastFinancialLimitReviewOnUtc = new Date();
                        params = {
                            lastFinancialLimitReviewOnUtc: lastFinancialLimitReviewOnUtc.toISOString(),
                        };
                        return [4 /*yield*/, magic.methods.users.updateUserProfile(params)];
                    case 1:
                        updatedProfile = _a.sent();
                        if (!updatedProfile) return [3 /*break*/, 3];
                        return [4 /*yield*/, window.eventBus.publish(USER_PROFILE_DATA, updatedProfile)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.emitSuccess();
                        notificationService.show(this.$t('acknowledge-deposit-limits.success'), {
                            style: NotificationStyle.SUCCESS,
                            uniqueID: 'acknowledge-deposit-limits.success',
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SetLimitsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jurisdiction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        jurisdiction = _a.sent();
                        this.isUKGC = isUKGC(jurisdiction);
                        this.initializeVariables();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SetLimitsComponent.prototype.initializeVariables = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.subscription = window.eventBus.subscribe(BALANCE_CURRENCY_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                    var maxCapConfig;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                this.currency = (_a = event.payload) !== null && _a !== void 0 ? _a : Currency.EUR;
                                return [4 /*yield*/, configQuery('limits.maxCap')];
                            case 1:
                                maxCapConfig = _b.sent();
                                this.responsibleGamingLimitCap = objectValueOrDefault(maxCapConfig, this.currency);
                                return [2 /*return*/];
                        }
                    });
                }); }, { replay: true });
                return [2 /*return*/];
            });
        });
    };
    SetLimitsComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    /**
     * Emits the error returned by the backend when
     * an error occurs when setting the limits.
     * @param error
     */
    SetLimitsComponent.prototype.emitError = function (error) {
        return error;
    };
    /**
     * Emits the new limits that have been set once
     * the limits have all been successfully set.
     * @param newLimits The set limit values
     */
    SetLimitsComponent.prototype.emitSuccess = function (newLimits) {
        return newLimits;
    };
    SetLimitsComponent.prototype.getLimitCap = function (period) {
        if (!this.responsibleGamingLimitCap.length) {
            return DEFAULT_MAX_CAP;
        }
        var gamingLimits = this.responsibleGamingLimitCap;
        var parsedLimit = gamingLimits[0][this.getPeriodIndex(period)];
        this.currentPeriodMaxError = parsedLimit;
        return isNaN(parsedLimit) ? DEFAULT_MAX_CAP : parsedLimit;
    };
    SetLimitsComponent.prototype.getPeriodIndex = function (period) {
        switch (period) {
            case CoreXLimitDuration.ONE_DAY:
                return 0;
            case CoreXLimitDuration.ONE_WEEK:
                return 1;
            case CoreXLimitDuration.ONE_MONTH:
                return 2;
            default:
                return 0;
        }
    };
    __decorate([
        ValidationGuard(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SetLimitsComponent.prototype, "setLimits", null);
    __decorate([
        Emit('error'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SetLimitsComponent.prototype, "emitError", null);
    __decorate([
        Emit('success'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SetLimitsComponent.prototype, "emitSuccess", null);
    SetLimitsComponent = __decorate([
        Component({
            name: 'corex-set-limits',
            validations: function () {
                var _this = this;
                var periodValidators = PERIODS.reduce(function (prev, curr) {
                    prev[curr.period] = {
                        minValue: minValue(1),
                        maxValue: maxValue(_this.getLimitCap(curr.period)),
                        numeric: numeric,
                    };
                    return prev;
                }, {});
                return {
                    depositValues: __assign(__assign({}, periodValidators), { atLeastOne: function () { return _this.validateAtLeastOne(); } }),
                };
            },
        })
    ], SetLimitsComponent);
    return SetLimitsComponent;
}(Mixins(MagicConfigMixin, validationMixin)));

export default SetLimitsComponent;
